import api from '@pray/shared/utils/api';

import type { SeedSettingsResponse } from './types';

const SETTINGS_URL = '/web/studio/admin/seed-emails/settings';

/**
 * The tracking header name of each data source (Inbox Monster, SparkPost Email Analyst), each with
 * who changed it last and when.
 *
 * The names are account-level, so they live on the server and not in the browser: a run created by
 * another admin has to carry the same headers the vendor accounts expect.
 */
export async function getSettings() {
  const res = await api.executeGetRequest<{ data: SeedSettingsResponse }>(SETTINGS_URL);
  return res.data.data;
}
